<template>
    <div class="go-simple-card" :style="extendStyle">
        <slot></slot>
    </div>
</template>

<script>
    import {AssertUtils} from 'goingutils';

    export default {
        name: "go-simple-card",
        props: {
            height: {}
        },
        computed: {
            extendStyle() {
                let backJson = {};
                //如果存在高度
                if (AssertUtils.isNotNull(this.height)) {
                    backJson["height"] = this.height + "px";
                }
                return backJson;
            }
        },
        methods: {},
        mounted() {
        },
        components: {}
    };
</script>




// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-simple-card.vue